export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  OTP: /^\d{6}$/,
};

export const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return { isValid: false, message: 'Email is required' };
  }
  if (!REGEX.EMAIL.test(email)) {
    return { isValid: false, message: 'Invalid email format' };
  }

  return { isValid: true, message: '' };
};

export const validateOTP = (otp) => {
  if (!otp || otp.trim() === '') {
    return { isValid: false, message: 'OTP is required' };
  }
  if (!REGEX.OTP.test(otp)) {
    return { isValid: false, message: 'Invalid OTP format' };
  }

  return { isValid: true, message: '' };
};
